import { render } from "./Item.ce.vue?vue&type=template&id=2c672936"
import script from "./Item.ce.vue?vue&type=script&lang=js"
export * from "./Item.ce.vue?vue&type=script&lang=js"

import _style_0 from "./Item.ce.vue?vue&type=style&index=0&id=2c672936&inline&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__